import request from './request'

export function listAssignmentToShift(data) {
  return request.post('/production/assignment-to-shift/list', data)
}
export function getAssignmentToShift(id) {
  return request.get('/production/assignment-to-shift/' + id)
}
export function saveAssignmentToShift(data) {
  return request.post('/production/assignment-to-shift', data)
}
export function updateAssignmentToShift(data) {
  return request.post('/production/assignment-to-shift/update', data)
}
export function deleteAssignmentToShift(ids) {
  return request.post('/production/assignment-to-shift/delete', ids)
}
export function acceptAssignmentToShift(assignmentId) {
  return request.post('/production/assignment-to-shift/accept', { assignmentId })
}
